import { library as FontAwesomeLibrary, dom } from "@fortawesome/fontawesome-svg-core"

// SOLID (per-icon subpath imports)
import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle"
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown"
import { faPhone } from "@fortawesome/pro-solid-svg-icons/faPhone"
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope"
import { faTimesCircle } from "@fortawesome/pro-solid-svg-icons/faTimesCircle"
import { faTicketSimple } from "@fortawesome/pro-solid-svg-icons/faTicketSimple"
import { faPercent } from "@fortawesome/pro-solid-svg-icons/faPercent"
import { faCalendarWeek } from "@fortawesome/pro-solid-svg-icons/faCalendarWeek"
import { faHouseNight } from "@fortawesome/pro-solid-svg-icons/faHouseNight"
import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser"
import { faChild } from "@fortawesome/pro-solid-svg-icons/faChild"
import { faBaby } from "@fortawesome/pro-solid-svg-icons/faBaby"
import { faDog as faDogSolid } from "@fortawesome/pro-solid-svg-icons/faDog"
import { faStarSharp } from "@fortawesome/pro-solid-svg-icons/faStarSharp"
import { faSuitcase as faSuitcaseSolid } from "@fortawesome/pro-solid-svg-icons/faSuitcase"
import { faLocationDot as faLocationDotSolid } from "@fortawesome/pro-solid-svg-icons/faLocationDot"
import { faCircleCheck as faCircleCheckSolid } from "@fortawesome/pro-solid-svg-icons/faCircleCheck"
import { faArrowsRotate } from "@fortawesome/pro-solid-svg-icons/faArrowsRotate"
import { faCircleSterling } from "@fortawesome/pro-solid-svg-icons/faCircleSterling"
import { faSquareQuestion } from "@fortawesome/pro-solid-svg-icons/faSquareQuestion"

// REGULAR (per-icon subpath imports)
import { faSearch } from "@fortawesome/pro-regular-svg-icons/faSearch"
import { faPlay } from "@fortawesome/pro-regular-svg-icons/faPlay"
import { faGasPump } from "@fortawesome/pro-regular-svg-icons/faGasPump"
import { faSquareCheck } from "@fortawesome/pro-regular-svg-icons/faSquareCheck"
import { faCalendar } from "@fortawesome/pro-regular-svg-icons/faCalendar"
import { faGear } from "@fortawesome/pro-regular-svg-icons/faGear"
import { faCar } from "@fortawesome/pro-regular-svg-icons/faCar"
import { faGauge } from "@fortawesome/pro-regular-svg-icons/faGauge"
import { faCamera } from "@fortawesome/pro-regular-svg-icons/faCamera"
import { faEngine } from "@fortawesome/pro-regular-svg-icons/faEngine"
import { faBars } from "@fortawesome/pro-regular-svg-icons/faBars"
import { faSuitcase } from "@fortawesome/pro-regular-svg-icons/faSuitcase"
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck"
import { faSquare } from "@fortawesome/pro-regular-svg-icons/faSquare"
import { faCircle as faCircleRegular } from "@fortawesome/pro-regular-svg-icons/faCircle"
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck"
import { faCaretUp } from "@fortawesome/pro-regular-svg-icons/faCaretUp"
import { faLocationDot } from "@fortawesome/pro-regular-svg-icons/faLocationDot"
import { faLock } from "@fortawesome/pro-regular-svg-icons/faLock"
import { faPaw } from "@fortawesome/pro-regular-svg-icons/faPaw"
import { faDog } from "@fortawesome/pro-regular-svg-icons/faDog"
import { faHotTubPerson } from "@fortawesome/pro-regular-svg-icons/faHotTubPerson"
import { faWifi } from "@fortawesome/pro-regular-svg-icons/faWifi"
import { faShower } from "@fortawesome/pro-regular-svg-icons/faShower"
import { faBath } from "@fortawesome/pro-regular-svg-icons/faBath"
import { faBedFront } from "@fortawesome/pro-regular-svg-icons/faBedFront"
import { faAlarmClock } from "@fortawesome/pro-regular-svg-icons/faAlarmClock"
import { faBellConcierge } from "@fortawesome/pro-regular-svg-icons/faBellConcierge"
import { faRadio } from "@fortawesome/pro-regular-svg-icons/faRadio"
import { faMugSaucer } from "@fortawesome/pro-regular-svg-icons/faMugSaucer"
import { faCarSide } from "@fortawesome/pro-regular-svg-icons/faCarSide"


// BRANDS (per-icon subpath imports)
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook"
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram"
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter"
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest"
import { faPinterestP } from "@fortawesome/free-brands-svg-icons/faPinterestP"
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin"
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn"
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter"
import { faTiktok } from "@fortawesome/free-brands-svg-icons/faTiktok"

// LIGHT (per-icon subpath imports)
import { faAngleLeft } from "@fortawesome/pro-light-svg-icons/faAngleLeft"
import { faAngleRight } from "@fortawesome/pro-light-svg-icons/faAngleRight"
import { faAngleDown } from "@fortawesome/pro-light-svg-icons/faAngleDown"
import { faAngleUp } from "@fortawesome/pro-light-svg-icons/faAngleUp"
import { faGift } from "@fortawesome/pro-light-svg-icons/faGift"
import { faCalendarAlt } from "@fortawesome/pro-light-svg-icons/faCalendarAlt"
import { faBook } from "@fortawesome/pro-light-svg-icons/faBook"
import { faMouseAlt } from "@fortawesome/pro-light-svg-icons/faMouseAlt"
import { faArrowRightLong } from "@fortawesome/pro-light-svg-icons/faArrowRightLong"
import { faArrowLeftLong } from "@fortawesome/pro-light-svg-icons/faArrowLeftLong"
import { faArrowDownLong } from "@fortawesome/pro-light-svg-icons/faArrowDownLong"
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons/faCircleInfo"
import { faXmark } from "@fortawesome/pro-light-svg-icons/faXmark"
import { faBars as faBarsLight } from "@fortawesome/pro-light-svg-icons/faBars"
import { faSpinnerThird } from "@fortawesome/pro-light-svg-icons/faSpinnerThird"
import { faPlus } from "@fortawesome/pro-light-svg-icons/faPlus"
import { faCircleXmark } from "@fortawesome/pro-light-svg-icons/faCircleXmark"
import { faCircleCheck as faCircleCheckLight } from "@fortawesome/pro-light-svg-icons/faCircleCheck"
import { faSunBright } from "@fortawesome/pro-light-svg-icons/faSunBright"
import { faMoon } from "@fortawesome/pro-light-svg-icons/faMoon"
import { faPhone as faPhoneLight } from "@fortawesome/pro-light-svg-icons/faPhone"
import { faHouse } from "@fortawesome/pro-light-svg-icons/faHouse"
import { faMessages } from "@fortawesome/pro-light-svg-icons/faMessages"

FontAwesomeLibrary.add(
  // light
  faBarsLight,
  faBook,
  // regular
  faPaw,
  faDog,
  faDogSolid,
  faHotTubPerson,
  faWifi,
  faShower,
  faBath,
  faBedFront,
  faAlarmClock,
  faBellConcierge,
  faRadio,
  faMugSaucer,
  faCarSide,
  faPlay,
  // brands
  faYoutube,
  faFacebook,
  faInstagram,
  faTwitter,
  faPinterest,
  faLinkedin,
  faLinkedinIn,
  faFacebookF,
  faPinterestP,
  // solid/regular mix
  faCircle,
  faCaretDown,
  faBars,
  faPhone,
  faEnvelope,
  // light
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faAngleUp,
  faGift,
  faCalendarAlt,
  // regular
  faSearch,
  // solid
  faTimesCircle,
  // light
  faMouseAlt,
  // regular
  faSuitcase,
  // brands
  faXTwitter,
  // regular
  faGasPump,
  faSquareCheck,
  faCar,
  faGear,
  faGauge,
  faCalendar,
  faEngine,
  faCamera,
  // light
  faArrowRightLong,
  faArrowLeftLong,
  faArrowDownLong,
  faCircleInfo,
  // solid
  faTicketSimple,
  faPercent,
  faCalendarWeek,
  faHouseNight,
  faUser,
  faChild,
  faBaby,
  faDog,
  faStarSharp,
  // light
  faXmark,
  faSpinnerThird,
  faPlus,
  // solid
  faSuitcaseSolid,
  // regular
  faCheck,
  faSquare,
  faCircleRegular,
  faCircleCheck,
  // light
  faCircleCheckLight,
  // solid
  faCircleCheckSolid,
  // light
  faCircleXmark,
  // regular
  faCaretUp,
  faLocationDot,
  // solid
  faLocationDotSolid,
  // brands
  faTiktok,
  // regular
  faLock,
  // light
  faSunBright,
  faMoon,
  // solid
  faArrowsRotate,
  // light
  faPhoneLight,
  // light
  faHouse,
  faMessages,
  // solid
  faCircleSterling,
  faSquareQuestion,
)

dom.watch()
